<template>
    <div>
        <div class="listing-header">
            <search-input :value="searchStr" @input="search($event)"></search-input>
        </div>
        <b-table
            :data="data"
            :loading="loading"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            @page-change="onPageChange"
            backend-sorting
            :default-sort-direction="defaultSortDirection"
            :default-sort="[sortField, sortDir]"
            @sort="onSort"
        >
            <template slot-scope="props">
                <b-table-column field="modified" label="Fecha de subida" sortable>
                    {{ props.row.modified }}
                </b-table-column>
                <b-table-column field="type" label="Tipo" sortable>
                    {{ props.row.type }}
                </b-table-column>
                <b-table-column field="name" label="Archivo" sortable>
                    {{ props.row.name }}
                </b-table-column>
                <b-table-column label="Actions">
                    <div>
                    <span @click="downloadRow(props.row.type, props.row.name)">
                        <b-icon icon="download"/>
                    </span>
                        <span @click="deleteRow(props.row.name)">
                        <b-icon icon="delete"/>
                    </span>
                    </div>
                </b-table-column>

            </template>
        </b-table>
    </div>
</template>

<script>
    import {Local} from '../../lib/Request';
    import SearchInput from "../fields/SearchInput";

    export default {
        name: "ProgrammingListing",
        components: {SearchInput},
        data: () => {
            return {
                data: [],
                total: 0,
                loading: false,
                sortField: 'modified',
                sortDir: 'desc',
                defaultSortDirection: 'desc',
                page: 0,
                perPage: 10,
                dateFormat: process.env.MIX_DBT_DATE_FORMAT,
                searchStr: null,
            }
        },
        created() {
            this.fetchData()
        },
        computed: {
            searchQuery() {
                return this.searchStr !== null && this.searchStr.length >= 2 ? this.searchStr : '';
            }
        },
        methods: {
            async fetchData() {
                try {
                    const result = await Local.get('/programming/listing', {
                        params: {
                            'page': this.page,
                            'sortField': this.sortField,
                            'sortDir': this.sortDir,
                            'searchQuery': this.searchQuery
                        }
                    });
                    console.log(result.data);
                    this.data = result.data.data;
                    this.total = result.data.total;
                } catch (error) {
                    // todo add toast notification
                    console.error(error);
                }
            },
            onPageChange(page) {
                this.page = page;
                this.fetchData()
            },
            onSort(field, direction) {
                this.sortField = field;
                this.sortDir = direction;
                this.fetchData()
            },
            async downloadRow(fileType, fileName) {
                const result = await Local.post(`/programming/download`, {'type': fileType, 'file': fileName});
                const url = window.URL.createObjectURL(new Blob([result.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            },
            async deleteRow(fileName) {
                try {
                    const confirmation = confirm('Are you sure?');
                    if (!confirmation) {
                        return;
                    }
                    // todo add modal for confirming deletion
                    const result = await Local.delete(`/programming/${fileName}`);
                    if (!(result && result.data && result.data.success)) {
                        throw new Error('Backend error');
                    }
                    this.$buefy.toast.open({
                        message: 'Item deleted',
                        type: 'is-success'
                    })
                    this.fetchData()
                } catch (error) {
                    console.error(error);
                    this.$buefy.toast.open({
                        duration: 5000,
                        closable: true,
                        message: 'Something went wrong',
                        type: 'is-danger'
                    });
                }
            },
            search(value) {
                this.searchStr = value
                this.fetchData()
            }
        }
    }

</script>

<style lang="scss">

</style>
